import React, { useMemo } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  IconButton,
  Button,
  Collapse,
  Chip,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import moment from "moment";
import PulseLoader from "react-spinners/PulseLoader";

const GroupList = ({
  productList,
  setProductList,
  handleDialogClose,
  loading,
  onSubmit,
  readOnly,
  height,
}) => {
  // Group products by product_id and product_variation_id
  const groupedProducts = useMemo(() => {
    const groups = {};

    productList.forEach((product) => {
      const key = `${product.product_id}_${product.product_variation_id}`;

      if (!groups[key]) {
        groups[key] = {
          product_id: product.product_id,
          product_variation_id: product.product_variation_id,
          product_name: product?.product_data?.[0]?.name || "---------",
          variation_name:
            product?.product_variation_data?.[0]?.name || "---------",
          items: [],
        };
      }

      groups[key].items.push(product);
    });

    return Object.values(groups);
  }, [productList]);

  const handleRemoveItem = (skuNumber) => {
    setProductList(productList?.filter((res) => res.sku_number !== skuNumber));
  };

  return (
    <Box
      sx={{
        mt: 1,
        background: "#fff",
        border: "1px solid #EAECF1",
        borderRadius: "12px",
        overflow: "hidden",
        padding: "16px 0",
        boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
      }}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ px: 1.5, mb: 1.75 }}
      >
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 2, xl: 2 }}>
          <Typography
            variant="h6"
            gutterBottom
            component="div"
            sx={{ color: "#0F1624", fontWeight: 600, margin: 0 }}
          >
            List ({productList?.length} items in {groupedProducts.length}{" "}
            groups)
          </Typography>
        </Grid>
      </Grid>
      <div
        style={{
          overflowX: "auto",
          minWidth: "100%",
          width: "Calc(100vw - 385px)",
          boxSizing: "border-box",
        }}
      >
        <TableContainer
          sx={{ height: height ? height : "Calc(100vh - 590px)" }}
        >
          <Table stickyHeader aria-label="grouped table">
            <TableHead>
              <TableRow>
                <TableCell style={{ whiteSpace: "nowrap" }}>
                  Product Name & SKU Numbers
                </TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }}>Quantity</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {groupedProducts.map((group, groupIndex) => (
                <TableRow key={groupIndex}>
                  <TableCell sx={{ minWidth: "300px" }}>
                    <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                      {group.product_name} &nbsp; {group.variation_name}
                    </Typography>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {group.items.map((item) => (
                        <Chip
                          key={item.sku_number}
                          label={item.sku_number}
                          onDelete={
                            readOnly
                              ? undefined
                              : () => handleRemoveItem(item.sku_number)
                          }
                          size="small"
                          sx={{
                            backgroundColor: "#F2F4F7",
                            color: "#344054",
                            fontWeight: 500,
                            "& .MuiChip-deleteIcon": {
                              color: "#667085",
                              "&:hover": {
                                color: "#344054",
                              },
                            },
                          }}
                        />
                      ))}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>
                    {group.items.length}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {!readOnly && (
          <Box
            sx={{
              px: 2,
              pt: 1,
              textAlign: "right",
              borderTop: "1px solid #EAECF0",
            }}
          >
            <Button
              variant="outlined"
              onClick={handleDialogClose}
              sx={{
                px: 2,
                py: 1.25,
                fontSize: "14px",
                fontWeight: 600,
                color: "#344054",
                border: "1px solid #D0D5DD",
                boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
              }}
            >
              Cancel
            </Button>
            &nbsp;
            <Button
              variant="contained"
              disabled={loading}
              // type="submit"
              sx={{
                px: 2,
                py: 1.25,
                fontSize: "14px",
                fontWeight: 600,
                minWidth: "127px",
                minHeight: "44px",
              }}
              // style={{ minWidth: "180px", minHeight: "35px" }}

              disableElevation
              onClick={onSubmit}
            >
              <PulseLoader
                color={"#4B46E5"}
                loading={loading}
                size={10}
                speedMultiplier={0.5}
              />{" "}
              {loading === false && "Submit"}
            </Button>
          </Box>
        )}
      </div>
    </Box>
  );
};

export default GroupList;
